import { Buffer } from "buffer";
import { ComputeBudgetProgram } from "@solana/web3.js";
export const COMPUTE_BUDGET_PROGRAM = ComputeBudgetProgram.programId.toBase58();
const ASSERTION_COMPUTE_UNITS = 20000n;
const ASSERTION_PRIORITY_FEE_RESERVE_LAMPORTS = 10000n;
/** Only the two explicitly prepared budget settings may be rewritten. */
function budget(message) {
    let units, price;
    for (const ix of message.compiledInstructions) {
        if (message.staticAccountKeys[ix.programIdIndex]?.toBase58() !== COMPUTE_BUDGET_PROGRAM)
            continue;
        if (ix.accountKeyIndexes.length)
            return null;
        const data = Buffer.from(ix.data);
        if (data[0] === 2 && data.length === 5 && units === undefined)
            units = BigInt(data.readUInt32LE(1));
        else if (data[0] === 3 && data.length === 9 && price === undefined)
            price = data.readBigUInt64LE(1);
        else
            return null;
    }
    return units !== undefined && units > 0n && units <= 1400000n && price !== undefined ? { units, price } : null;
}
/** Preserve fee-neutral rebalancing. Validated wallet assertions may also add
 * 20k units each, with at most 10k extra lamports and no higher unit price. */
export function withinPreparedComputeBudget(before, after, assertions) {
    const prepared = budget(before), approved = budget(after);
    if (!prepared || !approved || approved.price > prepared.price || !Number.isInteger(assertions) || assertions < 1 || assertions > 16)
        return false;
    const fee = (value) => (value.units * value.price + 999999n) / 1000000n;
    const preparedFee = fee(prepared), approvedFee = fee(approved);
    return approvedFee <= preparedFee || (approved.units <= prepared.units + BigInt(assertions) * ASSERTION_COMPUTE_UNITS
        && approvedFee <= preparedFee + ASSERTION_PRIORITY_FEE_RESERVE_LAMPORTS);
}
